import { LoginMethod, Market } from "../../models/Market";

export const REQUEST_CURRENT_MARKET = "REQUEST_CURRENT_MARKET";
export const REQUEST_MARKETS = "REQUEST_MARKETS";
export const REQUEST_LOGIN_METHODS = "REQUEST_LOGIN_METHODS";

export interface FetchMarkets {
  type: typeof REQUEST_MARKETS;
  payload: ReadonlyArray<Market>;
}

export type MarketActionTypes = FetchMarkets;

export interface MarketState {
  markets: ReadonlyArray<Market>;
}

export interface FetchCurrentMarket {
  type: typeof REQUEST_CURRENT_MARKET;
  payload: Market;
}

export type CurrentMarketActionTypes = FetchCurrentMarket;

export interface CurrentMarketState {
  market: Market;
}

export interface FetchLoginMethods {
  type: typeof REQUEST_LOGIN_METHODS;
  payload: ReadonlyArray<LoginMethod>;
}

export type LoginMethodActionTypes = FetchLoginMethods;

export interface LoginMethodState {
  loginMethods: ReadonlyArray<LoginMethod>;
}
